import { Component, Output, EventEmitter, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-ep-generic-dialog',
  templateUrl: './ep-generic-dialog.component.html',
  styleUrls: ['./ep-generic-dialog.component.scss'],
})
export class EpGenericDialogComponent {
  @HostBinding('class.ep-dialog') host = true;
  @Input() dialogTitle?: string = undefined;
  @Input() dialogTitle2?: string = undefined;
  @Input() isPrimary = false;
  @Output() cancelClick = new EventEmitter();

  public onCancel(): void {
    this.cancelClick.emit();
  }
}
